import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleContentPermissionsRoutingModule } from './role-content-permissions-routing.module';
import { DxDataGridModule, DxTextAreaModule, DxPopupModule, DxDropDownBoxModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { SettingsService } from '../settings.service';
import { RoleContentPermissionsComponent } from './role-content-permissions.component';

@NgModule({
  declarations: [RoleContentPermissionsComponent],
  imports: [
    CommonModule,
    RoleContentPermissionsRoutingModule,
    DxDataGridModule,
    DevEpressCommonModule,
    DxTextAreaModule,
    DxPopupModule,DxDropDownBoxModule
  ],
  providers: [SettingsService]
})
export class RoleContentPermissionsModule { }
